import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Search, ChevronDown, Facebook, Instagram } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  
  const isHomepage = location.pathname === '/';
  const isDarkHeroPage = ['/', '/donativos', '/carreiras'].includes(location.pathname);

  const searchableContent = [
    { title: 'Sobre Nós - Missão', link: '/institucional?tab=missao', keywords: 'missão valores equipa institucional sobre' },
    { title: 'Sobre Nós - Visão', link: '/institucional?tab=visao', keywords: 'visão futuro objetivos' },
    { title: 'Sobre Nós - Valores', link: '/institucional?tab=valores', keywords: 'valores princípios ética' },
    { title: 'Sobre Nós - Equipa', link: '/institucional?tab=equipa', keywords: 'equipa colaboradores profissionais' },
    { title: 'Reabilitação Psicossocial', link: '/intervencao?servico=reabilitacao', keywords: 'reabilitação psicossocial saúde mental intervenção' },
    { title: 'Fórum Sócio-Ocupacional', link: '/intervencao?servico=forum-socio-ocupacional', keywords: 'fórum ocupacional atividades' },
    { title: 'Apoio Psicológico', link: '/intervencao?servico=apoio-psicologico', keywords: 'psicologia apoio psicológico consulta' },
    { title: 'Apoio Social', link: '/intervencao?servico=apoio-social', keywords: 'social apoio assistência' },
    { title: 'Orientação Profissional', link: '/intervencao?servico=apoio-profissional', keywords: 'profissional emprego orientação trabalho' },
    { title: 'TIS - Teatro de Inclusão Social', link: '/projetos?projeto=tis', keywords: 'teatro inclusão social arte tis' },
    { title: 'Podcast - A falar é que a gente se entende', link: '/projetos?projeto=podcast', keywords: 'podcast rádio comunicação' },
    { title: 'Feira da Saúde', link: '/projetos?projeto=feira-saude', keywords: 'feira saúde evento comunidade' },
    { title: 'Oficinas Romani', link: '/projetos?projeto=romani', keywords: 'romani cidadania empreendedorismo' },
    { title: 'A Hora da Empatia', link: '/projetos?projeto=hora-empatia', keywords: 'empatia crianças escola' },
    { title: 'JOBSTER', link: '/projetos?projeto=jobster', keywords: 'jobster emprego jovens desemprego' },
    { title: 'Casalinho Comum', link: '/projetos?projeto=casalinho-comum', keywords: 'casalinho comunidade' },
    { title: 'Entre os Montes', link: '/projetos?projeto=entre-os-montes', keywords: 'montes rural comunidade' },
    { title: 'Notícias', link: '/noticias', keywords: 'notícias novidades atualidades' },
    { title: 'Agenda - Eventos', link: '/eventos', keywords: 'agenda eventos atividades calendário workshop formação' },
    { title: 'Contactos', link: '/contactos', keywords: 'contactos contacto email telefone morada' },
    { title: 'Ajude-nos - Donativos', link: '/donativos', keywords: 'donativos ajuda apoio contribuir donativo' },
    { title: 'Carreiras - Candidaturas', link: '/carreiras', keywords: 'carreiras emprego candidaturas trabalhar vagas' },
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const results = searchableContent.filter(item => 
        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.keywords.toLowerCase().includes(searchQuery.toLowerCase())
      );
      if (results.length > 0) {
        navigate(results[0].link);
        setIsSearchOpen(false);
        setSearchQuery('');
      }
    }
  };

  const filteredResults = searchQuery.trim() 
    ? searchableContent.filter(item => 
        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.keywords.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];
  
  const toggleSection = (sectionTitle) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionTitle]: !prev[sectionTitle]
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuSections = [
    { 
      title: 'INSTITUCIONAL',
      items: [
        { label: 'Missão, Visão e Valores', link: '/institucional?tab=missao' },
        { label: 'Sustentabilidade', link: '/institucional?tab=sustentabilidade' },
        { label: 'Ser Sócio', link: '/institucional?tab=socio' },
        { label: 'Informação Geral', link: '/institucional?tab=info-geral' },
        { label: 'Equipa', link: '/institucional?tab=equipa' }
      ]
    },
    { 
      title: 'INTERVENÇÃO',
      items: [
        { label: 'Reabilitação Psicossocial', link: '/intervencao?servico=reabilitacao' },
        { label: 'Fórum Sócio Ocupacional', link: '/intervencao?servico=forum-socio-ocupacional' },
        { label: 'Apoio Psicológico', link: '/intervencao?servico=apoio-psicologico' },
        { label: 'Apoio Social', link: '/intervencao?servico=apoio-social' },
        { label: 'Orientação Profissional', link: '/intervencao?servico=apoio-profissional' }
      ]
    },
    { 
      title: 'PROJETOS',
      items: [
        { label: 'Elos & Elas', link: '/projetos?projeto=elos-elas' },
        { label: "AMAR'ELA", link: '/projetos?projeto=amarela' },
        { label: 'A Hora da Empatia', link: '/projetos?projeto=hora-empatia' },
        { label: 'TIS - Teatro de Inclusão Social', link: '/projetos?projeto=tis' },
        { label: 'Oficinas Romani', link: '/projetos?projeto=romani' },
        { label: 'Bairro Leitor', link: '/projetos?projeto=bairro-leitor' },
        { label: 'CASAlinho COMUM', link: '/projetos?projeto=casalinho-comum' },
        { label: 'JOBSTER', link: '/projetos?projeto=jobster' },
        { label: "Projeto D'Ajuda", link: '/projetos?projeto=dajuda' },
        { label: 'Entre os Montes', link: '/projetos?projeto=entre-os-montes' }
      ]
    }
  ];

  const directLinks = [
    { label: 'NOTÍCIAS', link: '/noticias' },
    { label: 'AGENDA', link: '/eventos' },
    { label: 'AJUDE-NOS', link: '/donativos' },
    { label: 'CONTACTOS', link: '/contactos' }
  ];

  const handleNavClick = (link) => {
    navigate(link);
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`header-minimal ${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''} ${isDarkHeroPage && !isScrolled ? 'on-dark' : ''}`} data-testid="header">
        <div className="header-minimal-container">
          <Link to="/" className="logo-minimal" onClick={() => setIsMenuOpen(false)}>
            <img 
              className="logo-spin"
              src="https://customer-assets.emergentagent.com/job_c5613bb1-a850-4f1e-a125-9abce62f2fd6/artifacts/5ilt6pjf_30715585_1661938427218177_6934498318873526272_n-removebg-preview.png" 
              alt="AASPS Logo" 
            />
          </Link>
          
          <div className="header-actions">
            <a href="http://facebook.com/aasps" target="_blank" rel="noopener noreferrer" className="icon-btn social-icon" title="Facebook">
              <Facebook size={20} />
            </a>
            <a href="https://instagram.com/aasps_pt" target="_blank" rel="noopener noreferrer" className="icon-btn social-icon" title="Instagram">
              <Instagram size={20} />
            </a>
            <button className="icon-btn" onClick={() => setIsSearchOpen(!isSearchOpen)} title="Pesquisar" data-testid="search-toggle">
              <Search size={22} />
            </button>
            <button 
              className="menu-toggle" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Menu"
              data-testid="menu-toggle"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </header>

      {/* Search Overlay - rendered via portal */}
      {isSearchOpen && ReactDOM.createPortal(
        <div 
          className="search-overlay" 
          data-testid="search-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(26, 54, 93, 0.97)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: '150px',
            boxSizing: 'border-box'
          }}
        >
          <div className="search-container" style={{ width: '100%', maxWidth: '600px', padding: '0 20px' }}>
            <form onSubmit={handleSearch} className="search-form" style={{ display: 'flex', alignItems: 'center', background: 'white', borderRadius: '8px', padding: '16px 20px', gap: '12px' }}>
              <Search size={20} style={{ color: '#666', flexShrink: 0 }} />
              <input
                type="text"
                placeholder="Pesquisar..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
                style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '18px', color: '#1a365d', outline: 'none' }}
                data-testid="search-input"
              />
              <button type="button" onClick={() => { setIsSearchOpen(false); setSearchQuery(''); }} style={{ background: 'transparent', border: 'none', color: '#666', cursor: 'pointer', padding: '4px', display: 'flex' }}>
                <X size={24} />
              </button>
            </form>
            {filteredResults.length > 0 && (
              <div style={{ marginTop: '20px', background: 'white', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', overflow: 'hidden', maxHeight: '400px', overflowY: 'auto' }}>
                {filteredResults.map((result, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      navigate(result.link);
                      setIsSearchOpen(false);
                      setSearchQuery('');
                    }}
                    style={{ display: 'block', width: '100%', padding: '16px 20px', textAlign: 'left', background: 'transparent', border: 'none', borderBottom: '1px solid #f0f0f0', fontSize: '16px', color: '#1a365d', cursor: 'pointer' }}
                  >
                    {result.title}
                  </button>
                ))}
              </div>
            )}
            {searchQuery.trim() && filteredResults.length === 0 && (
              <div style={{ marginTop: '20px', textAlign: 'center', color: 'white', fontSize: '15px' }}>
                Nenhum resultado encontrado para "{searchQuery}"
              </div>
            )}
          </div>
        </div>,
        document.body
      )}

      <div 
        className={`menu-overlay ${isMenuOpen ? 'open' : ''}`} 
        onClick={() => setIsMenuOpen(false)}
      />

      <div className={`fullscreen-menu ${isMenuOpen ? 'open' : ''}`} data-testid="fullscreen-menu">
        <nav className="fullscreen-nav">
          {menuSections.map((section, idx) => (
            <div key={idx} className="menu-section">
              <button 
                className={`menu-section-header ${expandedSections[section.title] ? 'expanded' : ''}`}
                onClick={() => toggleSection(section.title)}
              >
                {section.title}
                <ChevronDown size={18} className="chevron-icon" />
              </button>
              <ul className={`menu-section-items ${expandedSections[section.title] ? 'expanded' : ''}`}>
                {section.items.map((item, itemIdx) => (
                  <li key={itemIdx}>
                    <button onClick={() => handleNavClick(item.link)}>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          
          <div className="menu-direct-links">
            {directLinks.map((item, idx) => (
              <button 
                key={idx} 
                className="menu-direct-link"
                onClick={() => handleNavClick(item.link)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
